import React, { useState } from 'react';
import ModalPodcast from '../../../../components/elements/ModalPodcast';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setPodcast } from '../../../../slices/podcastSlice';
import wave from "../../../../assets/wave.svg"
import { Calendar } from 'lucide-react';

const podcasts = [
  {
    nombre: "Radio Ambulante",
    descripcion: "Un podcast narrativo que cuenta historias latinoamericanas con un enfoque en temas humanos, culturales y sociales.",
    status: "Approved",
    pago: true
  },
  {
    nombre: "El Hilo",
    descripcion: "Un podcast semanal que profundiza en un tema de actualidad en América Latina, ofrece análisis detallado sobre noticias importantes de la región.",
    status: "Pending",
    pago: false
  },
  {
    nombre: "Cosas de Internet",
    descripcion: "Un podcast que explora las curiosidades, tendencias y fenómenos de la cultura digital. Con un tono ligero y divertido.",
    status: "Rejected",
    pago: false
  }
];

export default function Account() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [podcastData, setPodcastData] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleModal = (podcast) => {
    dispatch(setPodcast(podcast));
    navigate(`/client/podcast/${podcast.nombre}`);
  };

  const location = useLocation()
  



  
  

  return (
    <div className='w-full bg-background  px-10  font-poppina'>

      <div className="w-full py-2 flex gap-3 border-b ">
      <p onClick={() => navigate("/client") } className={`cursor-pointer ml-4 font-semibold ${location.pathname === "/client" ? "text-indigo-500" : ""}`} >Cuenta</p>
        <p>Calendario</p>

      </div>

      <div className="podcast text-center mb-10 shadow rounded-lg mt-3  ">
        <div className="relative ">
          <img className="absolute w-full sm:h-[220px] h-[250px] object-cover rounded-lg " src={wave} alt="" />
          <div className="relative z-10  ">
            <h1 className="text-white sm:text-6xl text-3xl font-bold pt-16 font-poppins ">
              <h1>Hola Rodrigo Silva!</h1>
            </h1>

            
            
          </div>
        </div>
        
        <div className="bg-background mt-24 p-8 relative rounded-lg   transform transition-all ">
        <p className="text-gray-600 dark:text-white text-xl font-light max-w-2xl mx-auto leading-relaxed">
              
            </p>
          
        </div>
      </div>

      <div>
        <h1 className='text-text font-semibold text-2xl md:text-4xl  '>Mis podcast</h1>
      </div>

      <div className='flex flex-wrap mt-5 gap-4 md:gap-6 w-full '>
        {podcasts.map((podcast, index) => (
          <div
            key={index}
            onClick={() => handleModal(podcast)}
            className='bg-background flex flex-col flex-1 justify-between border cursor-pointer border-gray-200 w-full md:w-[400px] h-48 rounded-lg shadow-sm p-4 md:p-5 hover:shadow-md transition-shadow duration-300'
          >
            <div>
              <h1 className='text-lg md:text-xl font-semibold mb-2 md:mb-3 text-text'>{podcast.nombre}</h1>
              <p className='text-xs sm:text-sm text-subtitle'>{podcast.descripcion}</p>
            </div>

            <div>
              <p className={`w-24 text-center rounded ${podcast.status === "Approved" ? "bg-green-100 text-green-700" : podcast.status === "Rejected" ? "bg-red-100 text-red-600" : "bg-yellow-100 text-yellow-800"}`}>
                {podcast.status}
              </p>
            </div>
          </div>
        ))}
      </div>
      <ModalPodcast isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} podcast={podcastData} />
    </div>
  );
}